import { createSelector } from 'reselect';

const selectSettings = () => (state) => state.get('administrationLdapSettings');

const makeSelectConfiguration = () =>
  createSelector(selectSettings(), (substate) => substate.get('configuration'));
const makeSelectCA = () =>
  createSelector(selectSettings(), (substate) => substate.get('ca'));
const makeSelectDataModified = () =>
  createSelector(selectSettings(), (substate) => substate.get('dataModified'));
const makeSelectGroupData = () =>
  createSelector(selectSettings(), (substate) => substate.get('groupData'));
const makeSelectGroupDataLoading = () =>
  createSelector(selectSettings(), (substate) =>
    substate.get('groupDataLoading'),
  );
const makeSelectShowFileUpload = () =>
  createSelector(selectSettings(), (substate) =>
    substate.get('showFileUpload'),
  );
const makeSelectGroupErrors = () =>
  createSelector(selectSettings(), (substate) => substate.get('groupErrors'));
const makeSelectRoles = () =>
  createSelector(selectSettings(), (substate) => substate.get('roles'));

export {
  makeSelectCA,
  makeSelectDataModified,
  makeSelectConfiguration,
  makeSelectGroupData,
  makeSelectGroupDataLoading,
  makeSelectShowFileUpload,
  makeSelectGroupErrors,
  makeSelectRoles,
};
